import { NTSReflection } from '@nts/std/utility';
import { ClassConstructor } from '@nts/std/serialization';

const DTO_TYPE_META_DATA_IDENTIFICATION_KEY = 'dtoTypeDecoratorMetaDataKey';

/**
 * Definisce quale è la classe del dto
 */
export function DtoTypeDecorator<TDto>(dtoType: ClassConstructor<TDto>) {
    return (target: any) => {
        Reflect.defineMetadata(DTO_TYPE_META_DATA_IDENTIFICATION_KEY, dtoType, target);
    };
}

export class DtoTypeInspector {
    static META_DATA_KEY = DTO_TYPE_META_DATA_IDENTIFICATION_KEY;
    static DECORATOR_NAME = '@DtoTypeDecorator';

    static isApplied(subject: any): boolean {
        return NTSReflection.hasClassMetadata(
            DTO_TYPE_META_DATA_IDENTIFICATION_KEY, subject);
    }

    static getValue(subject: any): any {
        return NTSReflection.getClassMetadata(
            DTO_TYPE_META_DATA_IDENTIFICATION_KEY, subject);
    }
}
